export const ACTION_PROGRESS_BAR_CLOSED = 'ACTION_PROGRESS_BAR_CLOSED'
